<div class="top-area">
  @if (!isCollapsed) {
    <img
      class="navbar-logo-img"
      data-test-id="header-logo"
      src="/static/assets/images/2025-LevelAccess_Logo-Horizontal_Midnight-RGB.svg"
      alt="{{ 'level_access_home' | translate }}"
    />
  }

  <button
    ds-button
    data-test-id="toggle-menu-button"
    [ds-tooltip]="isCollapsed ? ('expand_menu' | translate) : ('collapse_menu' | translate)"
    [attr.aria-label]="isCollapsed ? ('expand_menu' | translate) : ('collapse_menu' | translate)"
    [tooltipPlacement]="DsTooltipPosition.right"
    [variant]="DsButtonVariants.microActionStacked"
    [hideMicroActionIcon]="true"
    (click)="toggleMenu()"
  >
    <ds-icon [icon]="Icons.Sidebar" [iconStyle]="IconStyles.Light" class="light-icon"></ds-icon>
    <ds-icon [icon]="Icons.Sidebar" [iconStyle]="IconStyles.Solid" class="solid-icon"></ds-icon>
  </button>
</div>

<div class="nav-content">
  @if (hasAccessToLauncher) {
    <app-navigation-context-switcher [isCollapsed]="isCollapsed"></app-navigation-context-switcher>
  }

  <vertical-navigation [isCollapsed]="isCollapsed"></vertical-navigation>
</div>
